// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.main-image-content[data-v-b7861c62] {
  position: relative;
  overflow: hidden;
}
.main-image-rule[data-v-b7861c62] {
  position: relative;
  display: flex;
  justify-content: center;
}
.main-image-section[data-v-b7861c62] {
  width: 25%;
  position: relative;
  text-align: center;
}
.section-top-boader[data-v-b7861c62] {
  position: absolute;
  width: 100%;
  top: 0;
  border-top: 1px solid black;
  overflow: hidden;
}
.main-image-section__title[data-v-b7861c62] {
  width: 100%;
  height: 7%;
  top: 0;
  margin-top: 5px;
  font-size: 20px;
  font-weight: bold;
}
.section-title-boader[data-v-b7861c62] {
  position: absolute;
  width: 100%;
  top: 7%;
  border-top: 1px solid black;
  overflow: hidden;
}
.main-image-input[data-v-b7861c62] {
  width: 25%;
  position: relative;
  text-align: center;
}
.input-top-boader[data-v-b7861c62] {
  position: absolute;
  width: 100%;
  top: 0;
  border-top: 1px solid black;
  overflow: hidden;
}
.main-image-input__title[data-v-b7861c62] {
  width: 100%;
  height: 7%;
  top: 0;
  margin-top: 5px;
  font-size: 20px;
  font-weight: bold;
}
.input-title-boader[data-v-b7861c62] {
  position: absolute;
  width: 100%;
  top: 7%;
  border-top: 1px solid black;
  overflow: hidden;
}
.main-image-control[data-v-b7861c62] {
  width: 50%;
}
.modal-image[data-v-b7861c62] {
  max-width: 70% !important;
  max-height: 90% !important;
  padding: 5% 10px;
  position: relative;
}
.modal-image[data-v-b7861c62]::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 1px;
  /*background-color: #000;*/
}
.modal-image[data-v-b7861c62]::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 1px;
  /*background-color: #000;*/
}
.main-image-horizontal-line[data-v-b7861c62] {
  border-top: 1px solid black;
}
.main-image-verticalline__left[data-v-b7861c62] {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 1px;
  background-color: black;
}
.main-image-verticalline__right[data-v-b7861c62] {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 1px;
  background-color: black;
}
.input-rule-type[data-v-b7861c62] {
  width: 90%;
  margin: 10px;
  border: 2px solid black;
  border-radius: 10px;
  padding: 10px;
}
.main-image-horizontal-line[data-v-b7861c62] {
  position: absolute;
  width: 50%;
  top: 85%;
  border-top: 1px solid black;
}
`, "",{"version":3,"sources":["webpack://./src/components/screenshotScanner/MainImageModal.vue"],"names":[],"mappings":";AA4HA;EACA,kBAAA;EACA,gBAAA;AACA;AAEA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AACA;AAEA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;AACA;AAEA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,2BAAA;EACA,gBAAA;AACA;AAEA;EACA,WAAA;EACA,UAAA;EACA,MAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AACA;AAEA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,2BAAA;EACA,gBAAA;AACA;AAEA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;AACA;AAEA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,2BAAA;EACA,gBAAA;AACA;AAEA;EACA,WAAA;EACA,UAAA;EACA,MAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AACA;AAEA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,2BAAA;EACA,gBAAA;AACA;AAEA;EACA,UAAA;AACA;AAEA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;AACA;AAEA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,0BAAA;AACA;AAEA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,0BAAA;AACA;AAEA;EACA,2BAAA;AACA;AAEA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;AACA;AAEA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;AACA;AAEA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACA;AAEA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AACA","sourcesContent":["<template>\n  <div class=\"main-image-modal__wrapper\">\n    <b-modal ref=\"mainImageModal\" centered static class=\"main-image-modal\" v-on:shown=\"onShown\">\n      <div class=\"main-image-content\">\n        <div class=\"main-image-rule d-flex justify-content-center\">\n          <div class=\"main-image-section\">\n            <div class=\"section-top-boader\"></div>\n            <div class=\"main-image-section__title\">\n              セクション\n              <div class=\"section-title-boader\"></div>\n            </div>\n            <div v-if=\"sections.length > 0\">\n              <div v-for=\"(section, i) in sections\" :key=\"section\" class=\"mt-3\">\n                {{ 'セクション' + (i + 1) }}\n              </div>\n            </div>\n            <b-button type=\"submit\" variant=\"primary\" class=\"mt-3\" v-on:click=\"addSection()\">セクション追加</b-button>\n            <div class=\"main-image-verticalline__left\"></div>\n          </div>\n          <div class=\"main-image-control d-flex flex-column align-items-center\">\n            <vue-cropper\n              ref=\"cropper\"\n              :initial-aspect-ratio=\"16 / 9\"\n              :src=\"$props.imageUrl\"\n              v-on:ready=\"onReady\"\n              :autoCrop=\"true\"\n              class=\"modal-image\"\n            />\n          </div>\n          <div class=\"main-image-input\">\n            <div class=\"input-top-boader\"></div>\n            <div class=\"main-image-verticalline__right\"></div>\n            <div class=\"main-image-input__title\">\n              ルール入力\n              <div class=\"input-title-boader\"></div>\n            </div>\n            <select class=\"input-rule-type\" aria-label=\"Select option\">\n              <option selected>Option 1</option>\n              <option value=\"2\">Option 2</option>\n              <option value=\"3\">Option 3</option>\n            </select>\n            <b-button type=\"submit\" variant=\"primary\" class=\"mt-3 btn btn-lg\">確定する</b-button>\n          </div>\n        </div>\n      </div>\n\n      <template #modal-footer>\n        <div>\n          <b-button @click=\"hide\">キャンセル</b-button>\n          <b-button variant=\"primary\">プレビュー</b-button>\n        </div>\n      </template>\n    </b-modal>\n  </div>\n</template>\n\n<script lang=\"ts\">\nimport Component from 'vue-class-component';\nimport KamigameVue from '@/KamigameVue';\nimport 'bootstrap-icons/font/bootstrap-icons.css';\nimport PinchZoom from 'vue-pinch-zoom';\nimport VueCropper from 'vue-cropperjs';\nimport 'cropperjs/dist/cropper.css';\n\n@Component({\n  name: 'main-image-modal',\n  components: {\n    PinchZoom,\n    VueCropper,\n  },\n  props: {\n    imageUrl: {\n      type: String,\n    },\n    file: {\n      type: Array as () => File[],\n    },\n  },\n})\nexport default class MainImageModal extends KamigameVue {\n  sections: string[] = [];\n  blobURL = '';\n\n  onShown() {\n    this.cropper.replace(this.$props.imageUrl);\n  }\n\n  flipX() {\n    const dom = this.$refs.flipX;\n    let scale = (dom as any).getAttribute('data-scale');\n    scale = scale ? -scale : -1;\n    (this.$refs.cropper as any).scaleX(scale);\n    (dom as any).setAttribute('data-scale', scale);\n  }\n\n  onReady() {\n    this.cropper.initCrop();\n  }\n\n  addSection() {\n    this.sections.push('');\n  }\n\n  zoom(percent: number) {\n    (this.$refs.cropper as any).relativeZoom(percent);\n  }\n\n  show() {\n    const mainImageModal = this.$refs.mainImageModal as any;\n    mainImageModal.show();\n  }\n\n  hide() {\n    const imageUploaderModal = this.$refs.mainImageModal as any;\n    imageUploaderModal.hide();\n  }\n\n  private get cropper() {\n    return this.$refs.cropper as any;\n  }\n}\n</script>\n\n<style scoped>\n.main-image-content {\n  position: relative;\n  overflow: hidden;\n}\n\n.main-image-rule {\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n\n.main-image-section {\n  width: 25%;\n  position: relative;\n  text-align: center;\n}\n\n.section-top-boader {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  border-top: 1px solid black;\n  overflow: hidden;\n}\n\n.main-image-section__title {\n  width: 100%;\n  height: 7%;\n  top: 0;\n  margin-top: 5px;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.section-title-boader {\n  position: absolute;\n  width: 100%;\n  top: 7%;\n  border-top: 1px solid black;\n  overflow: hidden;\n}\n\n.main-image-input {\n  width: 25%;\n  position: relative;\n  text-align: center;\n}\n\n.input-top-boader {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  border-top: 1px solid black;\n  overflow: hidden;\n}\n\n.main-image-input__title {\n  width: 100%;\n  height: 7%;\n  top: 0;\n  margin-top: 5px;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.input-title-boader {\n  position: absolute;\n  width: 100%;\n  top: 7%;\n  border-top: 1px solid black;\n  overflow: hidden;\n}\n\n.main-image-control {\n  width: 50%;\n}\n\n.modal-image {\n  max-width: 70% !important;\n  max-height: 90% !important;\n  padding: 5% 10px;\n  position: relative;\n}\n\n.modal-image::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 1px;\n  /*background-color: #000;*/\n}\n\n.modal-image::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 1px;\n  /*background-color: #000;*/\n}\n\n.main-image-horizontal-line {\n  border-top: 1px solid black;\n}\n\n.main-image-verticalline__left {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 1px;\n  background-color: black;\n}\n\n.main-image-verticalline__right {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 1px;\n  background-color: black;\n}\n\n.input-rule-type {\n  width: 90%;\n  margin: 10px;\n  border: 2px solid black;\n  border-radius: 10px;\n  padding: 10px;\n}\n\n.main-image-horizontal-line {\n  position: absolute;\n  width: 50%;\n  top: 85%;\n  border-top: 1px solid black;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
